import { ApsProjectUsersClient, GetProjectUsers200Response } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { useMutation, useQuery } from "@tanstack/react-query";
const apsProjectUsers = new ApsProjectUsersClient(undefined, axios);

export const useGetApsProjectUsers = (projectId: string, searchText: string, options?: any) => {
  return useQuery<GetProjectUsers200Response>({
    ...options,
    queryKey: ["apsUsers"],
    initialData: null,
    queryFn: async () => apsProjectUsers.getProjectUsers(projectId.replace(/^b\./, ''), projectId, searchText),
  });
};

export const useApsSyncUsers = (options?: any) => {
  return useMutation<void, unknown, void>({
    ...options,
    mutationFn: () => apsProjectUsers.syncApsUsers(),
  });
};
